import React from 'react';
import ReactDOM from 'react-dom/client'; // React 18 uses this
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
    // If pre-rendered by react-snap, use hydrateRoot for faster hydration
    ReactDOM.hydrateRoot(rootElement, <App />);
} else {
    // If not pre-rendered, use createRoot for normal rendering
    ReactDOM.createRoot(rootElement).render(<App />);
}

// Measure performance
reportWebVitals();
